import { render, staticRenderFns } from "./SubgroupAddPersonForm.vue?vue&type=template&id=24c4782d&"
import script from "./SubgroupAddPersonForm.vue?vue&type=script&lang=js&"
export * from "./SubgroupAddPersonForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports